/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Status_TargetInputs */

const en_sch_err_status_target = /** @type {(inputs: Sch_Err_Status_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That status cannot take the items. Choose another status of this workflow.`)
};

const de_sch_err_status_target = /** @type {(inputs: Sch_Err_Status_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Status kann die Vorgänge nicht aufnehmen. Wähle einen anderen Status dieses Workflows.`)
};

/**
* | output |
* | --- |
* | "That status cannot take the items. Choose another status of this workflow." |
*
* @param {Sch_Err_Status_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_status_target = /** @type {((inputs?: Sch_Err_Status_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Status_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_status_target(inputs)
	return en_sch_err_status_target(inputs)
});